"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentRoutes = void 0;
var AssignmentRoutes;
(function (AssignmentRoutes) {
    AssignmentRoutes["BasePrefix"] = "assignments";
    AssignmentRoutes["ById"] = ":assignmentId";
    AssignmentRoutes["AllByContract"] = "all/:contractId";
    AssignmentRoutes["AllByClientId"] = "all-client-assignment/:clientId";
    AssignmentRoutes["List"] = "list";
})(AssignmentRoutes = exports.AssignmentRoutes || (exports.AssignmentRoutes = {}));
